module.exports = __webpack_public_path__ + "img/06_Schnupperangebot-3@2x@2x.c418cc03.jpg";